<template>
  <div class="dashboard-form-setup">
    <h2>Setup your form</h2>
    <p>
      In order for us to collect submission data from any web form, you simply need to update your form's attribute action.
      Once this has been done you are all set to receive submissions
    </p>

    <h3>You already have a form?</h3>
    <p>Wonderful! Udpdate your form tag to look like this to start receiving forms.</p>
    <highlight-block-code :code="existingFormCode"></highlight-block-code>

    <h3>You don't have a form yet?</h3>
    <p>No problem. You can use this one as a starting point</p>
    <p>This example form only collects a user’s email address, but you’re free to add whatever inputs you need for your particular use case. We’ll collect whatever data you tell us to.</p>
    <highlight-block-code :code="newFormCode"></highlight-block-code>

    <highlight-block-warning>
      Email is a required field and must be setup like so: id="email" name="email"
    </highlight-block-warning>

  </div>
</template>

<script>
import HighlightBlockCode from '../HighlightBlockCode'
import HighlightBlockWarning from '../HighlightBlockWarning'

export default {
  name: 'DashboardFormSetup',
  components: {
    HighlightBlockCode,
    HighlightBlockWarning
  },
  data () {
    return {
    }
  },
  computed: {
    form () {
      return this.$store.getters['currentForm']
    },
    base_url_form () {
      return this.$store.getters['base_url_form']
    },
    formEndpoint () {
      return `${this.base_url_form}/f/${this.form.token}`
    },
    emailNote () {
      return 'Note: Email is a required field and must be setup like so: id="email" name="email"'
    },
    existingFormCode () {
      return `
<form
  accept-charset="UTF-8"
  action="${this.formEndpoint}"
  enctype="multipart/form-data"
  method="POST"
>
`
    },
    newFormCode () {
      return '' +
`<form 
  accept-charset="UTF-8" 
  action="${this.formEndpoint}" 
  enctype="multipart/form-data" 
  method="POST"
>
  <label for="email-address">Email Address</label>
  <input type="email" id="email" name="email" required>

  <textarea rows="4" cols="50" name="comment" required></textarea>

  <button type="submit">Submit</button>
</form>

`
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/DashboardFormSetup.vue